import { Link } from '@tanstack/react-router';
import { MarketingPage } from './Chrome';
import styles from './Marketing.module.css';

const FEATURES = [
  {
    title: 'Talk to it like a colleague',
    body: 'Ask for what you want in plain language. No forms to hunt through, no fields to remember — Resonance works out what you meant and does it.',
  },
  {
    title: 'Echo does the work, on the record',
    body: 'Your AI counterpart acts on your behalf and writes down everything it did. Filter the timeline to “Your Echo” to see the whole day at a glance — and undo any of it.',
  },
  {
    title: 'Your CRM, shaped to your work',
    body: 'New objects and fields appear the moment you ask for them. No schema migrations, no admin console, no waiting.',
  },
  {
    title: 'It talks to your other agents',
    body: 'Resonance coordinates the AI tools you already use, hands off work, and follows up — over the channels those agents already listen on.',
  },
];

export function LandingPage() {
  return (
    <MarketingPage>
      <section className={styles.hero}>
        <h1 className={styles.headline}>
          The CRM that <span className={styles.accent}>does the work</span>
        </h1>
        <p className={styles.sub}>
          Resonance pairs every person with an AI counterpart that keeps the record straight,
          moves deals forward, and tells you exactly what it did.
        </p>
        <Link to="/sign-in" className={styles.cta}>
          Get started
        </Link>
      </section>

      <section className={styles.grid}>
        {FEATURES.map((feature) => (
          <article key={feature.title} className={styles.card}>
            <h2 className={styles.cardTitle}>{feature.title}</h2>
            <p className={styles.cardBody}>{feature.body}</p>
          </article>
        ))}
      </section>
    </MarketingPage>
  );
}
